import { ROUTE_SEO_COUNTRY } from '..'
import AddressNotFoundError from '../../domain/error/AddressNotFoundError'
import PermanentRedirectError from '../../domain/error/PermanentRedirectError'
import { bboxArrayToBboxArrays } from '../../domain/map/conversion'
import { generateFullRoute } from '../../domain/router/routeUtils'
import { renderPage } from '../../domain/seo/country.page'
import { extractCodeLabel } from '../../domain/utils/location'
import { searchArea } from '../../store/address/address.actions'
import { selectFirstAddress } from '../../store/address/address.selectors'
import { mapUpdated } from '../../store/map/mapSlice'
import { geocodeForwardCtx, searchServiceCtx } from '../../store/search/search.service.constants'
import { setSearchTerms } from '../../store/search/searchSlice'
import { searchCountryCities } from '../../store/seo/seo-address.actions'
import { slugify } from '../../utils/string'
import { technicalErrorCatcher } from '../routeErrors.utils'
import { handleRouteLoading } from '../routeService'

export const onRouteEnter = ({ params, store: { dispatch, getState } }, avoidRefetchingPageData) => {
  if (avoidRefetchingPageData) {
    return Promise.resolve()
  }

  const { location } = params
  const { code, label } = extractCodeLabel(location)

  return searchArea(location, geocodeForwardCtx.filter.country)(dispatch, getState)
    .then(() => {
      const firstAddress = selectFirstAddress(getState())

      if (firstAddress.geocode_level !== searchServiceCtx.geocodeLevel.country || !firstAddress.countryCode) {
        throw new AddressNotFoundError()
      }

      if (firstAddress.countryCode !== code || slugify(firstAddress.countryLabel) !== label)
        throw new PermanentRedirectError(
          generateFullRoute(ROUTE_SEO_COUNTRY, {
            location: `${firstAddress.countryCode}-${slugify(firstAddress.countryLabel)}`
          })
        )

      return Promise.all([
        dispatch(setSearchTerms(label)),
        __SERVER__ && searchCountryCities()(dispatch, getState),
        dispatch(mapUpdated({ bbox: bboxArrayToBboxArrays(firstAddress.bbox) }))
      ])
    })
    .catch(technicalErrorCatcher)
}

export default handleRouteLoading({ onRouteEnter, renderPage })
